import axios from 'axios';
import { showMessage } from 'app/store/actions/fuse';
import { API_BASE_URL } from '@config';

export const syncAcmShapes = () => dispatch => {
  const url = `${API_BASE_URL}/api/settings/sync_acm_shapes`;
  const request = axios.get(url);
  return request
    .then(res => {
      dispatch(showMessage({ message: 'ACM Shapes Synced Successfully' }));
    })
    .catch(err => {
      dispatch(setError({ ...err.response, type: 'modal' }));
    });
};

export const syncCloudProviderShapes = (credentialId, region) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      if (!credentialId) {
        reject({
          message: 'Please select an AWS credential to sync shapes'
        });
        return;
      }
      
      if (!region) {
        reject({
          message: 'Please select a region to sync shapes'
        });
        return;
      }
      
      axios
        .post(`${API_BASE_URL}/api/shapes/sync`, { credentialId, region }, {
          headers: {
            'admin': true
          }
        })
        .then(response => {
          if (response.data.success) {
            dispatch(showMessage({ message: 'Cloud Provider Shapes Synced Successfully' }));
            resolve(response.data);
          } else {
            reject(response.data);
          }
        })
        .catch(error => {
          reject(error.response ? error.response.data : error);
        });
    });
  };
};

export const RELEASE_NODES = 'RELEASE_NODES';

export const releaseNodes = (hostnames) => dispatch => {
  if (!hostnames || !Array.isArray(hostnames) || hostnames.length === 0) {
    return dispatch(setError({ message: 'Invalid or empty hostnames array provided.', type: 'modal' }));
  }

  const url = `${API_BASE_URL}/api/settings/release_nodes`;
  const request = axios.post(url, { hostnames });

  return request
    .then(res => {
      dispatch(showMessage({ message: 'All Nodes Released Successfully' }));
      return res;
    })
    .catch(err => {
      dispatch(setError({ ...err.response, type: 'modal' }));
      throw err;
    });
};

export const SET_ERROR = 'SET_ERROR';
export const setError = data => ({
  type: SET_ERROR,
  payload: data
});

// Action types for ACM machines
export const SET_ACM_MACHINES = 'SET_ACM_MACHINES';
export const SET_STACK_ERROR = 'SET_STACK_ERROR';

// Action creators for ACM machines
export const setAcmMachines = data => ({
  type: SET_ACM_MACHINES,
  payload: data
});

export const setStackError = data => ({
  type: SET_STACK_ERROR,
  payload: data
});

// get ACM machines 
export const getAcmMachines = () => dispatch => {
  const request = axios.get(`${API_BASE_URL}/api/stacks/acm_machines`);
  return request
    .then(response => {
      dispatch(setAcmMachines(response.data));
    })
    .catch(err => {
      dispatch(setStackError({ ...err.data, type: 'modal' }));
    });
}

export const SET_ACM_ENABLED = 'SET_ACM_ENABLED';
export const setAmcEnabled = data => ({
  type: SET_ACM_ENABLED,
  payload: data
});

export const getAmcEnableStatus = () => dispatch => {
  const request = axios.get(`${API_BASE_URL}/api/settings/acm_enabled`);
  return request
    .then(response => {
      dispatch(setAmcEnabled(response.data.isEnabled));
    })
    .catch(err => {
      dispatch(setStackError({ ...err.data, type: 'modal' }));
    });
}

export const SET_AI_FEATURES_ENABLED = 'SET_AI_FEATURES_ENABLED';
export const setAiFeaturesEnabled = data => ({
  type: SET_AI_FEATURES_ENABLED,
  payload: data
});

export const getAiFeaturesEnabledStatus = () => dispatch => {
  const request = axios.get(`${API_BASE_URL}/api/settings/ai_features_enabled`);
  return request
    .then(response => {
      dispatch(setAiFeaturesEnabled(response.data.isEnabled));
    })
    .catch(err => {
      dispatch(setStackError({ ...err.data, type: 'modal' }));
    });
}

export const SET_CLUSTER_SETTINGS = 'SET_CLUSTER_SETTINGS';
export const setClusterSettings = data => ({
  type: SET_CLUSTER_SETTINGS,
  payload: data
});
export const getClusterSettings = () => dispatch => {
  const request = axios.get(`${API_BASE_URL}/api/settings/settings`);
  return request
    .then(response => {
      dispatch(setClusterSettings(response.data));
    })
    .catch(err => {
      dispatch(setStackError({ ...err.data, type: 'modal' }));
    });
}

export const updateClusterSettings = (newClusterSettings) => (dispatch) => {
  axios
    .put(`${API_BASE_URL}/api/settings/cluster`, {
      vncTokenAuthentication: newClusterSettings.vncTokenAuthentication,
      vncRemoteClient: newClusterSettings.vncRemoteClient,
      autoDestroyOnDeploymentFailure: newClusterSettings.autoDestroyOnDeploymentFailure,
      retryDestroyOnFailure: newClusterSettings.retryDestroyOnFailure,
      retryDestroyAttempts: newClusterSettings.retryDestroyAttempts,
      retryDestroyDelayMinutes: newClusterSettings.retryDestroyDelayMinutes,
      fastCapacityValidationDefault: newClusterSettings.fastCapacityValidationDefault,
    })
    .catch((err) => {
      dispatch(setStackError({ ...err.response.data, type: 'modal' }));
    });
};

export const SET_UI_SETTINGS = 'SET_UI_SETTINGS';
export const setUiSettings = data => ({
  type: SET_UI_SETTINGS,
  payload: data
});

export const getUiSettings = () => dispatch => {
  const request = axios.get(`${API_BASE_URL}/api/ui/settings`);
  return request
    .then(response => {
      dispatch(setUiSettings(response.data));
    })
    .catch(err => {
      dispatch(setStackError({ ...err.data, type: 'modal' }));
    });
}

export const SET_PROVIDERS_DATA = 'SET_PROVIDERS_DATA';
export const setProvidersData = data => ({
  type: SET_PROVIDERS_DATA,
  payload: data
});

export const getProvidersData = () => dispatch => {
  const request = axios.get(`${API_BASE_URL}/api/settings/providers`);
  return request
    .then(response => {
      dispatch(setProvidersData(response.data));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.data, type: 'modal' }));
    });
};

export const SET_HEALTH_SERVICE_STATUS = 'SET_HEALTH_SERVICE_STATUS';
export const setHealthServiceStatus = status => ({
  type: SET_HEALTH_SERVICE_STATUS,
  payload: status
});

export const getHealthServiceStatus = () => dispatch => {
  const request = axios.get(`${API_BASE_URL}/api/settings/health-service/status`);
  return request
    .then(response => {
      dispatch(setHealthServiceStatus(response.data));
      return response.data;
    })
    .catch(err => {
      console.error('Error fetching health service status:', err);
    });
};

export const SET_THEME = 'SET_THEME';
export const setTheme = theme => ({
  type: SET_THEME,
  payload: theme
});

export const getTheme = (organizationId = null) => dispatch => {
  const url = organizationId
    ? `${API_BASE_URL}/api/settings/theme?organizationId=${organizationId}`
    : `${API_BASE_URL}/api/settings/theme`;
  return axios.get(url)
    .then(response => {
      dispatch(setTheme(response.data.theme));
      return response.data;
    })
    .catch(err => {
      console.error('Error fetching theme:', err);
      // Default to 'default' theme on error
      dispatch(setTheme('default'));
    });
};

export const updateTheme = (theme, organizationId = null) => dispatch => {
  return axios
    .put(`${API_BASE_URL}/api/settings/theme`, { theme, organizationId })
    .then(response => {
      dispatch(setTheme(theme));
      dispatch(showMessage({ message: 'Theme updated successfully' }));
      return response.data;
    })
    .catch(err => {
      dispatch(setError({ ...err.response.data, type: 'modal' }));
      throw err;
    });
};

// Workshop Settings Actions
export const SET_WORKSHOP_SETTINGS = 'SET_WORKSHOP_SETTINGS';
export const setWorkshopSettings = data => ({
  type: SET_WORKSHOP_SETTINGS,
  payload: data
});

export const getWorkshopSettings = () => dispatch => {
  const request = axios.get(`${API_BASE_URL}/api/settings/workshop`);
  return request
    .then(response => {
      dispatch(setWorkshopSettings(response.data));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.data, type: 'modal' }));
    });
};

export const updateWorkshopSettings = (settings) => dispatch => {
  return axios
    .put(`${API_BASE_URL}/api/settings/workshop`, settings)
    .then(response => {
      dispatch(setWorkshopSettings(settings));
      dispatch(showMessage({ message: 'Workshop settings updated successfully' }));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

// Organization-Scoped Cluster Settings Actions
export const SET_ORG_CLUSTER_SETTINGS = 'SET_ORG_CLUSTER_SETTINGS';
export const setOrgClusterSettings = data => ({
  type: SET_ORG_CLUSTER_SETTINGS,
  payload: data
});

export const SET_SELECTED_SETTINGS_ORG = 'SET_SELECTED_SETTINGS_ORG';
export const setSelectedSettingsOrg = organizationId => ({
  type: SET_SELECTED_SETTINGS_ORG,
  payload: organizationId
});

/**
 * Get organization-scoped cluster settings
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const getOrgClusterSettings = (organizationId = null) => dispatch => {
  const url = organizationId
    ? `${API_BASE_URL}/api/settings/cluster-settings?organizationId=${organizationId}`
    : `${API_BASE_URL}/api/settings/cluster-settings`;
  const request = axios.get(url);
  return request
    .then(response => {
      dispatch(setOrgClusterSettings(response.data));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

/**
 * Update organization-scoped cluster settings
 * @param {Object} settings - Settings to update
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const updateOrgClusterSettings = (settings, organizationId = null) => dispatch => {
  return axios
    .put(`${API_BASE_URL}/api/settings/cluster-settings`, {
      ...settings,
      organizationId
    })
    .then(response => {
      dispatch(setOrgClusterSettings(response.data.settings));
      dispatch(showMessage({ message: 'Cluster settings updated successfully' }));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

/**
 * Get organization-scoped health thresholds
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const getOrgHealthThresholds = (organizationId = null) => {
  const url = organizationId
    ? `${API_BASE_URL}/api/settings/cluster-settings/health-thresholds?organizationId=${organizationId}`
    : `${API_BASE_URL}/api/settings/cluster-settings/health-thresholds`;
  return axios.get(url).then(response => response.data);
};

/**
 * Update organization-scoped health thresholds
 * @param {Object} thresholds - Thresholds to update
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const updateOrgHealthThresholds = (thresholds, organizationId = null) => dispatch => {
  return axios
    .post(`${API_BASE_URL}/api/settings/cluster-settings/health-thresholds`, {
      ...thresholds,
      organizationId
    })
    .then(response => {
      dispatch(showMessage({ message: 'Health thresholds updated successfully' }));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

// ============================================================================
// Organization-Scoped Health Service Enable/Disable Actions
// ============================================================================

/**
 * Get organization-scoped health service status
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const getOrgHealthServiceStatus = (organizationId = null) => {
  const url = organizationId
    ? `${API_BASE_URL}/api/settings/cluster-settings/health-service/status?organizationId=${organizationId}`
    : `${API_BASE_URL}/api/settings/cluster-settings/health-service/status`;
  return axios.get(url).then(response => response.data);
};

/**
 * Enable organization-scoped health service
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const enableOrgHealthService = (organizationId = null) => dispatch => {
  const url = organizationId
    ? `${API_BASE_URL}/api/settings/cluster-settings/health-service/enable?organizationId=${organizationId}`
    : `${API_BASE_URL}/api/settings/cluster-settings/health-service/enable`;
  return axios
    .post(url, { organizationId })
    .then(response => {
      dispatch(showMessage({ message: 'Health monitoring enabled' }));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

/**
 * Disable organization-scoped health service
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const disableOrgHealthService = (organizationId = null) => dispatch => {
  const url = organizationId
    ? `${API_BASE_URL}/api/settings/cluster-settings/health-service/disable?organizationId=${organizationId}`
    : `${API_BASE_URL}/api/settings/cluster-settings/health-service/disable`;
  return axios
    .post(url, { organizationId })
    .then(response => {
      dispatch(showMessage({ message: 'Health monitoring disabled' }));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

// ============================================================================
// Organization-Scoped Provider Visibility Actions
// ============================================================================

export const SET_ORG_PROVIDER_VISIBILITY = 'SET_ORG_PROVIDER_VISIBILITY';
export const setOrgProviderVisibility = data => ({
  type: SET_ORG_PROVIDER_VISIBILITY,
  payload: data
});

/**
 * Get organization-scoped provider visibility settings
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const getOrgProviderVisibility = (organizationId = null) => dispatch => {
  const url = organizationId
    ? `${API_BASE_URL}/api/settings/cluster-settings/provider-visibility?organizationId=${organizationId}`
    : `${API_BASE_URL}/api/settings/cluster-settings/provider-visibility`;
  return axios
    .get(url)
    .then(response => {
      dispatch(setOrgProviderVisibility(response.data));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

/**
 * Update organization-scoped provider visibility settings
 * @param {Array} providerVisibility - Array of visible provider IDs
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const updateOrgProviderVisibility = (providerVisibility, organizationId = null) => dispatch => {
  return axios
    .put(`${API_BASE_URL}/api/settings/cluster-settings/provider-visibility`, {
      providerVisibility,
      organizationId
    })
    .then(response => {
      dispatch(setOrgProviderVisibility(response.data));
      dispatch(showMessage({ message: 'Provider visibility settings updated successfully' }));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

/**
 * Check if a specific provider is visible for an organization
 * @param {string} provider - Provider ID to check
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const checkOrgProviderVisibility = (provider, organizationId = null) => {
  return axios
    .post(`${API_BASE_URL}/api/settings/cluster-settings/provider-visibility/check`, {
      provider,
      organizationId
    })
    .then(response => response.data);
};

// ============================================================================
// Organization-Scoped ACM Settings Actions
// ============================================================================

export const SET_ORG_ACM_SETTINGS = 'SET_ORG_ACM_SETTINGS';
export const setOrgAcmSettings = data => ({
  type: SET_ORG_ACM_SETTINGS,
  payload: data
});

/**
 * Get organization-scoped ACM settings
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const getOrgAcmSettings = (organizationId = null) => dispatch => {
  const url = organizationId
    ? `${API_BASE_URL}/api/settings/cluster-settings/acm?organizationId=${organizationId}`
    : `${API_BASE_URL}/api/settings/cluster-settings/acm`;
  return axios
    .get(url)
    .then(response => {
      dispatch(setOrgAcmSettings(response.data.acmSettings));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

/**
 * Update organization-scoped ACM settings
 * @param {Object} settings - ACM settings to update (enabled, apiUrl, authToken)
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const updateOrgAcmSettings = (settings, organizationId = null) => dispatch => {
  return axios
    .put(`${API_BASE_URL}/api/settings/cluster-settings/acm`, {
      ...settings,
      organizationId
    })
    .then(response => {
      dispatch(setOrgAcmSettings(response.data.acmSettings));
      dispatch(showMessage({ message: 'ACM settings updated successfully' }));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

/**
 * Test ACM connection with provided or stored credentials
 * @param {string} apiUrl - ACM API URL to test (optional if testing stored)
 * @param {string} authToken - ACM Auth Token to test (optional if testing stored)
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const testOrgAcmConnection = (apiUrl, authToken, organizationId = null) => dispatch => {
  return axios
    .post(`${API_BASE_URL}/api/settings/cluster-settings/acm/test`, {
      apiUrl,
      authToken,
      organizationId
    })
    .then(response => {
      if (response.data.success) {
        dispatch(showMessage({ message: 'ACM connection successful' }));
      } else {
        dispatch(showMessage({ message: 'ACM connection failed: ' + (response.data.details || response.data.error), variant: 'error' }));
      }
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

/**
 * Get ACM machines for an organization
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const getOrgAcmMachines = (organizationId = null) => dispatch => {
  const url = organizationId
    ? `${API_BASE_URL}/api/settings/cluster-settings/acm/machines?organizationId=${organizationId}`
    : `${API_BASE_URL}/api/settings/cluster-settings/acm/machines`;
  return axios
    .get(url)
    .then(response => {
      dispatch(setAcmMachines(response.data.machines || []));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

/**
 * Sync ACM shapes for an organization
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const syncOrgAcmShapes = (organizationId = null) => dispatch => {
  const url = organizationId
    ? `${API_BASE_URL}/api/settings/sync_acm_shapes?organizationId=${organizationId}`
    : `${API_BASE_URL}/api/settings/sync_acm_shapes`;
  return axios
    .get(url)
    .then(res => {
      dispatch(showMessage({ message: 'ACM Shapes Synced Successfully' }));
      return res.data;
    })
    .catch(err => {
      dispatch(setError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

/**
 * Release ACM nodes for an organization
 * @param {Array} hostnames - Array of hostnames to release
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const releaseOrgAcmNodes = (hostnames, organizationId = null) => dispatch => {
  if (!hostnames || !Array.isArray(hostnames) || hostnames.length === 0) {
    return dispatch(setError({ message: 'Invalid or empty hostnames array provided.', type: 'modal' }));
  }

  return axios
    .post(`${API_BASE_URL}/api/settings/release_nodes`, { hostnames, organizationId })
    .then(res => {
      dispatch(showMessage({ message: 'All Nodes Released Successfully' }));
      return res.data;
    })
    .catch(err => {
      dispatch(setError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

/**
 * Get ACM enabled status for an organization
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const getOrgAcmEnabledStatus = (organizationId = null) => dispatch => {
  const url = organizationId
    ? `${API_BASE_URL}/api/settings/acm_enabled?organizationId=${organizationId}`
    : `${API_BASE_URL}/api/settings/acm_enabled`;
  return axios
    .get(url)
    .then(response => {
      dispatch(setAmcEnabled(response.data.isEnabled));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
    });
};

// ============================================================================
// Organization-Scoped Workshop Settings Actions
// ============================================================================

export const SET_ORG_WORKSHOP_SETTINGS = 'SET_ORG_WORKSHOP_SETTINGS';

export const setOrgWorkshopSettings = data => ({
  type: SET_ORG_WORKSHOP_SETTINGS,
  payload: data
});

/**
 * Get organization-scoped workshop default settings
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const getOrgWorkshopSettings = (organizationId = null) => dispatch => {
  const url = organizationId
    ? `${API_BASE_URL}/api/settings/cluster-settings/workshop?organizationId=${organizationId}`
    : `${API_BASE_URL}/api/settings/cluster-settings/workshop`;
  return axios
    .get(url)
    .then(response => {
      dispatch(setOrgWorkshopSettings(response.data.workshopSettings));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};

/**
 * Update organization-scoped workshop default settings
 * @param {Object} settings - Workshop settings to update (codeMode, style, enableSudoForAllUsers, enableClusterFallback)
 * @param {string|null} organizationId - Organization ID, or null for platform-level
 */
export const updateOrgWorkshopSettings = (settings, organizationId = null) => dispatch => {
  return axios
    .put(`${API_BASE_URL}/api/settings/cluster-settings/workshop`, {
      ...settings,
      organizationId
    })
    .then(response => {
      dispatch(setOrgWorkshopSettings(response.data.workshopSettings));
      dispatch(showMessage({ message: 'Workshop settings updated successfully' }));
      return response.data;
    })
    .catch(err => {
      dispatch(setStackError({ ...err.response?.data, type: 'modal' }));
      throw err;
    });
};
/**
 * Get error reporting opt-in setting
 */
export const getErrorReportingSettings = () => () => {
  return axios
    .get(`${API_BASE_URL}/api/settings/error-reporting`)
    .then(response => response.data)
    .catch(() => ({ enabled: false }));
};

/**
 * Toggle error reporting opt-in
 */
export const updateErrorReportingSettings = (enabled) => dispatch => {
  return axios
    .put(`${API_BASE_URL}/api/settings/error-reporting`, { enabled })
    .then(response => {
      dispatch(showMessage({
        message: enabled
          ? 'Error reporting enabled - thank you for helping improve Heidi AI'
          : 'Error reporting disabled',
        variant: 'success',
      }));
      return response.data;
    })
    .catch(err => {
      dispatch(showMessage({ message: 'Failed to update error reporting setting', variant: 'error' }));
      throw err;
    });
};

/**
 * Send an error report to heidiai.io via the fleet agent.
 * Used by the "Send Report" button in failure dialogs.
 * @param {string} eventType - e.g. 'error.cluster_deploy', 'error.stack_build'
 * @param {string} message - Human-readable summary
 * @param {Object} details - Sanitized details (no IPs, keys, or usernames)
 */
export const sendErrorReport = (eventType, message, details) => dispatch => {
  return axios
    .post(`${API_BASE_URL}/api/settings/send-error-report`, { event_type: eventType, message, details })
    .then(response => response.data)
    .catch(err => {
      dispatch(showMessage({ message: 'Failed to send error report', variant: 'error' }));
      throw err;
    });
};
